<template>
  <!-- 2カラムページの場合は'is-2column'クラスを付与 -->
  <!-- ヘッダーを隠すの場合は'is-hidden-header'クラスを付与 -->
  <div id="body"
    :class="{'is-hidden-header' : targetScrollFlg}"
    @scroll="handleScroll"
  >
  <BackgroundImage />

    <!-- menu:start -->
    <PCMenu
      class="visible"
      v-if="visibleMenu"
      @closeMenu="visibleMenu = false"
    />
    <!-- menu:end -->

    <!-- Cancel Input Popup -->
    <transition name="popup">
      <PCServiceLicenseCancelCancel
        v-if="state.visibleCancelInput"
        @closeAdmin="state.visibleCancelInput = false"
      />
    </transition>

    <div id="wrapper">
      <PCContractHeader />

      <!-- menu-bar:start -->
      <!-- open -->
      <div class="menu-bar" role="button"
        :class="{'is-open' : !targetScrollFlg}"
        @click="visibleMenu = !visibleMenu"
      >
        <IconMenu class="icn"
          v-if="!targetScrollFlg"
        />
        <FontawesomeIcon :icon="['far','chevron-up']" size="lg" class="icn"
          v-if="targetScrollFlg"
        />
      </div>
      <!-- close -->
      <!-- menu-bar:end -->

      <!-- content:start -->
      <div id="content"
        style="height:calc(100vh - 16px);"
      >
        <div class="service" id="scroll-target"
          @scroll="handleScroll"
        >
          <div class="service-head">
            <h1 class="hdg03">サービス管理</h1>
          </div>
          <form v-if="state.initialize" action="" method="post" class="service-container">
            <div class="service-content">
              <h2 class="hdg03">ご契約中のサービス</h2>
              <div class="service-content-payment">
                <p v-if="visibleDetailPackage.length > 0" class="txt">契約内容を確認したいサービスを選択してください。</p>
                <p v-else class="txt">ご契約中のサービスはありません。</p>
                <ul class="column gutter service-content-list">
                  <li v-for="(_package, index) in visibleDetailPackage" :key="'package_' + index" class="column-item col-4 space-gutter service-content-list-item">
                    <!-- <router-link :to="'/pc/service-detail'" class="service-box"> -->
                    <a @click.prevent="clickDetail(_package)" href="/pc/service-detail" class="service-box">
                      <div class="service-box-content">
                        <h3 class="hdg03">{{_package.package_name}}</h3>
                        <p class="txt">
                          [{{packageStatusWord(_package.package_status)}}]
                          <template v-if="packageStatusWord(_package.package_status) !== '自動継続'">
                            <br>{{packageEnd(_package.period_end)}}
                          </template>
                        </p>
                      </div>
                    </a>
                    <!-- </router-link> -->
                  </li>
                </ul>
              </div>
              <h2 class="hdg03">無料トライアルお申し込み、新規サービス・ライセンスのご購入をご検討の方へ</h2>
              <div class="service-content-payment">
                <div class="mt20 mb32">
                  <div v-if="state.isUnderExam">
                    <p class="txt">お支払い方法の審査を行っております。審査終了まで追加購入、ライセンス追加購入は行えませんのでご了承ください。</p>
                  </div>
                  <div v-else-if="state.boughtThisMonthDifPayment">
                    <p class="txt">既定のお支払い方法を変更した場合は当月の追加購入は行えません。翌月より追加購入を行えますのでご了承ください。</p>
                  </div>
                  <div v-else>
                    <p v-if="isAgreement" class="txt">新規サービス・ライセンスの追加購入をご希望される方は、「追加購入」ボタンからお進みください。</p>
                    <p v-else class="txt">ご希望の内容のボタンからお進みください。</p>
                  </div>
                </div>
                <ul class="service-btn-list">
                  <li class="service-btn-list-item">
                    <div :class="['button', canTrialProduct.length <= 0 && 'is-inactive']">
                      <router-link to="/pc/contract-free-trial" class="btn">無料トライアルの申込</router-link>
                    </div>
                  </li>
                  <li v-if="isAgreement" class="service-btn-list-item">
                    <div class="button" :class="(state.isUnderExam || state.boughtThisMonthDifPayment) ? 'is-inactive' : ''">
                      <a v-if="state.isUnderExam || state.boughtThisMonthDifPayment" href="javascript:void(0)" class="btn">追加購入</a>
                      <router-link v-else to="/pc/service-license-purchase-input" class="btn">追加購入</router-link>
                    </div>
                  </li>
                  <li v-if="!isAgreement" class="service-btn-list-item">
                    <div class="button">
                      <router-link to="/pc/new-application-input" class="btn">新規契約申込</router-link>
                    </div>
                  </li>
                  <li v-if="!isAgreement" class="service-btn-list-item">
                    <div class="button">
                      <router-link to="/pc/estimate-input" class="btn">お見積もり</router-link>
                    </div>
                  </li>
                </ul>
              </div>
              <p class="link">
                <a href="/lc/about/" target="_blank" class="contact-head-link">LEGAL CONNECTIONについて <FontawesomeIcon icon="external-link-alt" class="icn" /></a>
              </p>
            </div>
          </form>
        </div>
      </div>
      <!-- content:end -->
      <span id="btnTop" @click="scrollAreaTop('#scroll-target')">TOP</span>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'
import { Service } from '@/logic/contract/Service'

import PCContractHeader from '@/components/pc/partial/contract/ContractHeader.vue'
import PCMenu from '@/components/pc/popup/PCMenu.vue'

export default defineComponent({
  components: {
    PCContractHeader,
    PCMenu
  },
  setup (props, context) {
    return { ...Service(props, context) }
  }
})
</script>

<style lang="scss" scoped>
#header {
  @media screen and (max-width: 1250px) {
    .header-search-tab {
      position: relative;
      &-02 {
        position: absolute;
        top: 52px;
        background-color: #fff;
        border-radius: 4px;
        box-shadow: 0px 3px 6px rgba(0,0,0,.16);
        .header-search-tab-item {
          height: 48px;
          padding: 0 10px;
          a {
            color: $color-link;
            padding: 2px 10px;
            font-size: 1.4rem;
          }
        }
      }
    }
  }
}
#content {
  background-color: #fff;
  border-radius: 8px 8px 0 0;
  margin-bottom: 60px;
  overflow-y: auto;
}
.service {
  width: 100%;
  overflow: auto;
  &-container {
    border-top: 1px solid $color-line;
    padding: 40px 0 150px;
    .button .btn[type="submit"] {
      width: 230px;
      margin: 32px auto 0;
    }
  }
  &-head {
    padding: 30px 40px 25px;
    [class^="hdg"] {
      margin-bottom: 0;
    }
  }
  &-content {
    max-width: 1105px;
    padding: 0 40px;
    margin: 0 auto;
    .txt {
      line-height: 1.625;
    }
    .txt-red {
      color: #C95656 !important;
      line-height: 1.625;
    }
    .link{
      a{
        color: #005BAC;
      }
      svg{
        margin-left: 5px;
      }
    }
    &-payment {
      border-top: 1px solid $color-line;
      padding: 32px 0;
    }
    &-list{
      margin-top: 30px;
      &-item{
        border: 1px solid $color-line;
        border-radius: 4px;
        .hdg03{
          margin: 0 0 25px;
        }
      }
    }
  }

  &-btn-list{
    list-style: none;
    &-item{
      width: 230px;
      display: inline-block;
      margin-right: 20px;
    }
  }

  &-box{
    padding: 35px 20px 53px;
    display: block;
  }
}
</style>
